import { StsBackendOperation } from '../../../sts-backend-operation';
import { buildDtcCodePatchBody, type DtcCodeUpdateBodyParams } from '../helpers';

/**
 * Update an existing DTC code on a Techline case (e.g. change primary designation or freeze frame status).
 */
export class UpdateDtcCode extends StsBackendOperation {
    /**
     * Execute the update DTC code operation.
     *
     * @param params - the case number, DTC code, and optional update fields
     * @returns true if the update succeeded, false otherwise
     */
    async exec(params: DtcCodeUpdateBodyParams): Promise<boolean> {
        const { caseNumber, code, options } = params;
        const updateBody = buildDtcCodePatchBody(caseNumber, code, options);

        const response = await this.client.updateTechlineCaseDtcCode({ updateBody });

        return Boolean(response?.success);
    }
}
